class CartRecommendationsV2 extends HTMLElement {
  connectedCallback() {
    this.loadRecommendations();
    this.addEventListener('submit', (e) => this.onSubmit(e));
  }

  cheapestVariant(product) {
    const available = (product.variants || []).filter((v) => v.available);
    if (!available.length) return null;
    return available.reduce((min, v) => (v.price < min.price ? v : min));
  }

  loadRecommendations() {
    const productId = this.dataset.productId;
    if (!productId) return;
    const grid = this.querySelector('.recommendations-grid');

    fetch(`/recommendations/products.json?product_id=${productId}&limit=4`)
      .then((response) => response.json())
      .then((data) => {
        const items = (data.products || [])
          .map((product) => ({ product, variant: this.cheapestVariant(product) }))
          .filter((item) => item.variant)
          .slice(0, 2);

        if (!items.length) return;

        items.forEach(({ product, variant }) => {
          const price = variant.price / 100;
          const compare =
            variant.compare_at_price && variant.compare_at_price > variant.price
              ? variant.compare_at_price / 100
              : null;
          const image = (variant.featured_image && variant.featured_image.src) || product.featured_image;
          const url = `${product.url}?variant=${variant.id}`;

          const itemHTML = `
            <div class="recommendation-item w-[170px] relative">
              <a href="${url}">
                ${product.tags[0] ? `<span class="absolute top-[1rem] text-sm rounded-full bg-primary-flora text-primary-sereno py-0 px-2">${product.tags[0]}</span>` : ''}
                <div class="bg-neutral-100 rounded-xl w-[130px]">
                  <img class="mix-blend-multiply" src="${image}" alt="${product.title}">
                </div>
                <p class="text-primary-flora text-sm font-bold">${product.title}</p>
              </a>
              <div class="flex items-center gap-1 mt-1">
                ${compare ? `<p class="text-neutral-light text-sm line-through">${formatMoney(compare)}</p>` : ''}
                <p class="text-primary-vigor font-bold text-lg">${formatMoney(price)}</p>
              </div>
              <p class="text-neutral-light text-xs">ou ${installment_count}x de ${formatMoney(price / installment_count)}</p>
              <form action="/cart/add" method="post" class="mt-2">
                <input type="hidden" name="id" value="${variant.id}">
                <button type="submit" class="text-sm w-full bg-primary-flora text-primary-sereno py-1 px-2 rounded-2xl font-medium hover:bg-primary-vita hover:text-primary-flora transition-colors">
                  COMPRAR
                </button>
              </form>
            </div>
          `;
          grid.insertAdjacentHTML('beforeend', itemHTML);
        });

        this.querySelector('.product-recommendations__title').classList.remove('hidden');
      })
      .catch((error) => console.error(error));
  }

  async onSubmit(e) {
    const form = e.target.closest('form');
    if (!form) return;
    e.preventDefault();

    const button = form.querySelector('button');
    button.disabled = true;
    button.textContent = 'ADICIONANDO...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble'
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Erro ao adicionar');
      document.querySelector('cart-drawer').renderContents(data);
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = 'COMPRAR';
    }
  }
}

if (!customElements.get('cart-product-recommendations')) {
  customElements.define('cart-product-recommendations', CartRecommendationsV2);
}